// Field mapping templates for PunchOut connectors/systems.
// Each request type maps to the ordered list of field mapping names the
// template form offers. Add new request types here as they are supported.
export const punchOutTemplates = {
  PunchOutSetupRequest: [
    "Extrinsic.UserEmail",
    "Extrinsic.UniqueUsername",
    "Extrinsic.UserPrintableName",
    "Extrinsic.User",
    "Extrinsic.FirstName",
    "Extrinsic.LastName",
    "ShipTo.Address.@addressID",
    "ShipTo.Address.Name",
    "ShipTo.Address.Name.@xml:lang",
    "ShipTo.Address.PostalAddress.@name",
    "ShipTo.Address.PostalAddress.DeliverTo",
    "ShipTo.Address.PostalAddress.Street",
    "ShipTo.Address.PostalAddress.City",
    "ShipTo.Address.PostalAddress.State",
    "ShipTo.Address.PostalAddress.PostalCode",
    "ShipTo.Address.PostalAddress.Country.@isoCountryCode",
    "ShipTo.Address.PostalAddress.Country",
    "Callback.ClientId",
    "Callback.ClientGuid",
    "Callback.RunbookId",
    "Callback.RunbookGuid",
    "Callback.AccessToken",
    "DeploymentMode",
  ],
  OrderRequest: [
    "OrderRequestHeader.@orderID",
    "OrderRequestHeader.@orderDate",
    "OrderRequestHeader.@type",
    "OrderRequestHeader.Total.Money",
    "OrderRequestHeader.Total.Money.@currency",
    "OrderRequestHeader.ShipTo.Address.@addressID",
    "OrderRequestHeader.ShipTo.Address.Name",
    "OrderRequestHeader.ShipTo.Address.Name.@xml:lang",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.@name",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.DeliverTo",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.Street",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.City",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.State",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.PostalCode",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.Country.@isoCountryCode",
    "OrderRequestHeader.ShipTo.Address.PostalAddress.Country",
    "OrderRequestHeader.ShipTo.Address.Email",
    "OrderRequestHeader.ShipTo.Address.Phone.TelephoneNumber.CountryCode.@isoCountryCode",
    "OrderRequestHeader.ShipTo.Address.Phone.TelephoneNumber.CountryCode",
    "OrderRequestHeader.ShipTo.Address.Phone.TelephoneNumber.AreaOrCityCode",
    "OrderRequestHeader.ShipTo.Address.Phone.TelephoneNumber.Number",
    "OrderRequestHeader.BillTo.Address.@addressID",
    "OrderRequestHeader.BillTo.Address.Name",
    "OrderRequestHeader.BillTo.Address.Name.@xml:lang",
    "OrderRequestHeader.BillTo.Address.PostalAddress.@name",
    "OrderRequestHeader.BillTo.Address.PostalAddress.Street",
    "OrderRequestHeader.BillTo.Address.PostalAddress.City",
    "OrderRequestHeader.BillTo.Address.PostalAddress.State",
    "OrderRequestHeader.BillTo.Address.PostalAddress.PostalCode",
    "OrderRequestHeader.BillTo.Address.PostalAddress.Country.@isoCountryCode",
    "OrderRequestHeader.BillTo.Address.PostalAddress.Country",
    "OrderRequestHeader.BillTo.Address.Phone.TelephoneNumber.CountryCode.@isoCountryCode",
    "OrderRequestHeader.BillTo.Address.Phone.TelephoneNumber.CountryCode",
    "OrderRequestHeader.BillTo.Address.Phone.TelephoneNumber.AreaOrCityCode",
    "OrderRequestHeader.BillTo.Address.Phone.TelephoneNumber.Number",
    "OrderRequestHeader.Comments",
    "ItemOut",
    "DeploymentMode",
  ],
};

export const punchOutRequestTypes = Object.keys(punchOutTemplates);
